import { combineReducers } from 'redux'

import resultados from './detalhesPrestacao'
import documentosPrestacao from './documentosPrestacao'

export default combineReducers({
    resultados,
    documentosPrestacao,
})
